import React from 'react';
import "../../sass/components/sections/Header.scss"
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Logo from "../Logo"
import Menu from "./Menu"
import Fade from 'react-reveal/Fade';



export default function Header(props){
    return (
        <Fade top distance="5px">
        <header>
            <Container>
                <Row className="align-items-md-center">
                    <Col xs={{ span:'7' , order: '2' }} sm={{ span:'3' , order: '1' }}  md={{ span:'2' , order: '1' }}>
                        <Logo/>
                    </Col>
                    <Col xs={{ span:'12' , order: 'first' }} sm={{ span:'6' , order: '2' }} md={{ span:'8' , order: '2' }}>
                        <Menu/>
                    </Col>
                    <Col  xs={{ span:'5' , order: '3' }} sm={{ span:'3' , order: '3' }} md={{ span:'2' , order: '3' }} className="alignLeft">
                        <a type="button" className="btn btn-primary" href="/auth">ثبت نام</a>
                    </Col>
                </Row>
            </Container>
        </header>
        </Fade>
    )
}